import { gql } from "@apollo/client";

export const MESSAGE_TEMPLATE_FRAGMENT = gql`
  fragment MessageTemplateFragment on message_template {
    id
    type
    email_subject
    email_markup
    email_plain_text
    sms_body
    enabled
    message_template_rich_contents {
      content_id
      language
    }
  }
`;
